var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropellerAdsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121.1 42.1",
    style: {
      enableBackground: "new 0 0 121.1 42.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F2E500;}\n\t.st2{fill:#A9A500;}\n\t.st3{fill:#D8DADD;}\n\t.st4{fill:#898888;}\n\t.st5{fill:#474746;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.4,11.5c-0.8-0.7-1.9-1-3.4-1c-1,0-2,0.1-2.9,0.2c-0.1,0-0.2,0.1-0.2,0.3v11.2c0,0.2,0.1,0.3,0.3,0.3 h1.5c0.2,0,0.3-0.1,0.3-0.3v-4.2c0.3,0,0.6,0,0.9,0c1.6,0,2.9-0.5,3.7-1.3c0.6-0.7,1-1.5,1-2.6C37.5,13.1,37.1,12.2,36.4,11.5z  M32.9,16.4c-0.4,0-0.7,0-0.9-0.1v-4c0.2,0,0.6-0.1,1.1-0.1c1.1,0,2.4,0.3,2.4,1.9C35.4,16.1,33.8,16.4,32.9,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.9,13.7c-0.2,0-0.3-0.1-0.5-0.1c-0.8,0-1.6,0.4-2.1,1.1l0-0.6c0-0.2-0.1-0.3-0.3-0.3h-1.3 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.7,0.1,1.5,0.1,2.5v5.6c0,0.2,0.1,0.3,0.3,0.3h1.5c0.2,0,0.3-0.1,0.3-0.3 v-4.4c0-0.2,0-0.4,0.1-0.6c0.2-1,0.8-1.7,1.7-1.7c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2V14 C43.2,13.8,43.1,13.7,42.9,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.7,13.6c-2.6,0-4.3,1.9-4.3,4.6c0,2.6,1.7,4.5,4.2,4.5c2.1,0,4.4-1.4,4.4-4.6 C51.9,15.5,50.1,13.6,47.7,13.6z M49.8,18.2c0,1.7-0.9,2.9-2.2,2.9c-1.3,0-2.2-1.2-2.2-2.9c0-1.4,0.7-2.9,2.2-2.9 C49.3,15.3,49.8,17.2,49.8,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,13.6c-1.1,0-2,0.4-2.7,1.1l0-0.7c0-0.1-0.1-0.3-0.3-0.3h-1.3c-0.1,0-0.1,0-0.2,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.8,0.1,1.6,0.1,2.7v8.9c0,0.2,0.1,0.3,0.3,0.3h1.5c0.2,0,0.3-0.1,0.3-0.3v-3.7 c0.6,0.5,1.4,0.8,2.3,0.8c2,0,4-1.4,4-4.7C61.5,15.5,59.9,13.6,57.7,13.6z M59.4,18.1c0,1.8-0.8,2.9-2.2,2.9 c-0.9,0-1.7-0.6-2-1.5c0-0.2-0.1-0.4-0.1-0.6v-1.4c0-0.2,0-0.4,0.1-0.5c0.2-1,1.1-1.6,2-1.6C58.8,15.4,59.4,16.8,59.4,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,13.6c-2.4,0-4.1,1.9-4.1,4.7c0,2.7,1.7,4.4,4.3,4.4c1.4,0,2.3-0.3,2.8-0.5c0.1-0.1,0.2-0.2,0.2-0.3 l-0.3-1.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.2,0-0.2,0c-0.5,0.2-1.1,0.4-2.2,0.4c-0.7,0-2.3-0.2-2.5-2.3h5.4 c0.1,0,0.3-0.1,0.3-0.2l0-0.1c0-0.2,0-0.4,0-0.7C70,15.7,68.9,13.6,66.3,13.6z M64.3,17.1c0.2-0.8,0.7-1.9,1.9-1.9 c0.5,0,0.9,0.2,1.2,0.5c0.4,0.4,0.5,1,0.6,1.4H64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73,10h-1.5c-0.2,0-0.3,0.1-0.3,0.3v12c0,0.2,0.1,0.3,0.3,0.3H73c0.2,0,0.3-0.1,0.3-0.3v-12 C73.3,10.1,73.2,10,73,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77,10h-1.5c-0.2,0-0.3,0.1-0.3,0.3v12c0,0.2,0.1,0.3,0.3,0.3H77c0.2,0,0.3-0.1,0.3-0.3v-12 C77.3,10.1,77.2,10,77,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.8,13.6c-2.4,0-4.1,1.9-4.1,4.7c0,2.7,1.7,4.4,4.3,4.4c1.4,0,2.3-0.3,2.8-0.5c0.1-0.1,0.2-0.2,0.2-0.3 l-0.3-1.1c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.2,0-0.2,0c-0.5,0.2-1.1,0.4-2.2,0.4c-0.7,0-2.3-0.2-2.5-2.3h5.4 c0.1,0,0.3-0.1,0.3-0.2l0-0.1c0-0.2,0-0.4,0-0.6C86.4,15.7,85.3,13.6,82.8,13.6z M80.7,17.1c0.2-0.8,0.7-1.9,1.9-1.9 c0.5,0,0.9,0.2,1.2,0.5c0.4,0.4,0.5,1,0.6,1.4H80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.1,13.7c-0.2,0-0.3-0.1-0.5-0.1c-0.8,0-1.6,0.4-2.1,1.1l0-0.6c0-0.2-0.1-0.3-0.3-0.3h-1.3 c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.7,0.1,1.5,0.1,2.5v5.6c0,0.2,0.1,0.3,0.3,0.3h1.5c0.2,0,0.3-0.1,0.3-0.3 v-4.4c0-0.2,0-0.5,0.1-0.6c0.2-1,0.8-1.7,1.7-1.7c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2V14 C92.3,13.8,92.2,13.7,92.1,13.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.6,10.8c0-0.1-0.1-0.2-0.3-0.2h-1.8c-0.1,0-0.2,0.1-0.3,0.2l-3.9,11.4c0,0.1,0,0.2,0,0.3 c0.1,0.1,0.1,0.1,0.2,0.1h1.5c0.1,0,0.2-0.1,0.3-0.2l1.1-3.4h3.6l1.2,3.4c0,0.1,0.1,0.2,0.3,0.2h1.6c0,0,0,0,0,0 c0.2,0,0.3-0.1,0.3-0.3c0-0.1,0-0.1-0.1-0.2L98.6,10.8z M98.7,17.3h-2.6l1-2.9c0.1-0.3,0.2-0.7,0.3-1.1c0.1,0.4,0.2,0.7,0.3,1.1 L98.7,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111,20.2v-9.9c0-0.2-0.1-0.3-0.3-0.3h-1.5c-0.2,0-0.3,0.1-0.3,0.3v4.1c-0.5-0.5-1.3-0.8-2.2-0.8 c-1,0-1.9,0.4-2.6,1.1c-0.9,0.9-1.3,2.1-1.3,3.6c0,2.6,1.6,4.4,3.8,4.4c1,0,2-0.4,2.6-1.1l0,0.6c0,0.2,0.1,0.3,0.3,0.3h1.3 c0,0,0,0,0,0c0.2,0,0.3-0.1,0.3-0.3c0,0,0-0.1,0-0.1C111,21.5,111,20.7,111,20.2z M108.9,17.4v1.4c0,0.2,0,0.4-0.1,0.6 c-0.2,0.9-1,1.6-1.9,1.6c-1.6,0-2.1-1.4-2.1-2.7c0-1.7,0.9-2.9,2.2-2.9c1.1,0,1.7,0.8,1.9,1.5C108.9,17,108.9,17.3,108.9,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.9,17.3c-1.1-0.4-1.4-0.7-1.4-1.1c0-0.5,0.4-0.8,1.1-0.8c0.8,0,1.3,0.3,1.5,0.4c0.1,0,0.2,0.1,0.2,0 c0.1,0,0.1-0.1,0.2-0.2l0.4-1.1c0-0.1,0-0.3-0.1-0.3c-0.6-0.3-1.4-0.5-2.2-0.5c-1.8,0-3.1,1.1-3.1,2.7c0,0.8,0.4,1.9,2.3,2.6 c1.1,0.4,1.3,0.8,1.3,1.2c0,0.6-0.5,0.9-1.3,0.9c-0.7,0-1.4-0.3-1.8-0.5c-0.1,0-0.2-0.1-0.2,0c-0.1,0-0.1,0.1-0.2,0.2l-0.4,1.1 c0,0.1,0,0.3,0.1,0.3c0.6,0.4,1.5,0.6,2.4,0.6c2,0,3.3-1.1,3.3-2.7C118.2,18.7,117.5,17.9,115.9,17.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "8.2,36.6 2.8,30.1 12.7,23.8 15.2,23.8 6.1,30 10.5,35.6 8.2,36.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "8.8,36.3 10.4,38.3 12.7,38.4 10.5,35.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "15.4,27.7 32.6,36.9 34.8,35.6 15.8,27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.4,27.7 10.5,35.6 12.7,38.4 14.8,37.3 15.7,27.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "16.3,28.2 17.7,37 18.8,34.9 17.9,29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "15.7,27.9 15.7,27.9 14.9,36.7 17.7,37 16.3,28.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "16.8,23.8 15.2,23.8 10.6,4.9 12,3.7 16.8,23.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.6,9.9 8,8.2 15.2,23.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "8,8.2 15.2,23.8 11.2,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "15.2,23.8 12.7,23.8 4.6,15.5 5.5,13.4 15.2,23.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "8.1,12.3 5.5,13.4 15.2,23.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.3,24.3 28.3,24.3 26.9,23.5 19.2,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "28.3,24.3 19.3,24.3 28.3,26.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "10.5,35.6 6.1,30 15.2,23.8 16.8,23.8 12,3.7 18.6,5.1 19.3,24.3 35.5,29 34.8,35.6 15.8,27  10.5,35.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "22.9,21.1 20.4,20.7 19.2,21.4 19.2,23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "19.2,23.5 23.9,23.5 22.9,21.1 19.2,23  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropellerAdsLogo);
export default __webpack_public_path__ + "static/media/PropellerAds_logo.bad21306993acda42b65fc0d6fb6ed6e.svg";
export { ForwardRef as ReactComponent };